import React, { useState, useEffect } from 'react';
import { formatPrice, changeDecimalTo } from 'utils/';
import {
  DEFAULT_CURRENCY,
  CURRENT_LANG_PREFIX,
  COUNTRY,
  IS_ARABIC
} from 'constants/index';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';

import RefundIcon from 'assets/icons/refund.png';
import RewardIcon from 'assets/icons/reward.png';
import SummaryIcon from 'assets/icons/summary-list.png';

import { translate } from 'constants/language';
import { isBrowser } from 'react-device-detect';
import TransTable from './TransTable';
import Button from '../../../components/libs/Buttons';

export default ({
  creditHistory,
  returnableAmount,
  bankTransferCreditConfig
}) => {
  const lastTransaction = creditHistory && creditHistory[0];
  const history = useHistory();

  const [canTransferCredit, setCanTransferCredit] = useState(false);

  const transferCreditDesc =
    bankTransferCreditConfig &&
    bankTransferCreditConfig.translations &&
    bankTransferCreditConfig.translations.transfer_credit_desc;

  const goToNext = id => {
    return history.push(`/${CURRENT_LANG_PREFIX}/account/${id}`);
  };

  const transferCredit = () => {
    return history.push(`/${CURRENT_LANG_PREFIX}/account/transfer/credits`);
  };

  useEffect(() => {
    if (
      returnableAmount &&
      Number(returnableAmount) > 0 &&
      bankTransferCreditConfig &&
      bankTransferCreditConfig.transferrable_credit_min_value_flag &&
      Number(returnableAmount) >
        Number(bankTransferCreditConfig.transferrable_credit_min_value_flag)
    ) {
      setCanTransferCredit(true);
    } else {
      setCanTransferCredit(false);
    }
  }, [returnableAmount]);

  return (
    <div className={classnames('mb-32', isBrowser ? '' : 'mt-50')}>
      <div className="pt-32 pb-16 ta-c bg-light-gray bb-white-two">
        <div className="fs-18 fw-6 lh-24 c-secondary-neutral en-font">
          {formatPrice(
            (lastTransaction && changeDecimalTo(lastTransaction.balance, 2)) ||
              0,
            null,
            {
              currency: DEFAULT_CURRENCY,
              maximumFractionDigits: 2,
              minimumFractionDigits: 2
            }
          )}
        </div>
        <div className="mt-4 fs-14 fw-6 lh-18 c-dark-gray">
          {translate('Current Credit Balance')}
        </div>
        <If
          condition={
            bankTransferCreditConfig &&
            bankTransferCreditConfig.bank_transfer_credit_enabled &&
            bankTransferCreditConfig.country_enabled[COUNTRY] &&
            canTransferCredit
          }
        >
          <div className="mt-4 fs-14 lh-18 c-brown-gray">
            {translate('Eligible for bank transfer SAR ')}
            {returnableAmount ? Number(returnableAmount).toFixed(2) : ''}
          </div>
          <div className="pt-16 pb-10 pl-50 pr-50">
            <Button
              className="fs-14 d-block b-none w100p mb-8 cap"
              isBordered={true}
              onClick={transferCredit}
            >
              {translate('Transfer Credit')}
            </Button>
          </div>
          <div className="pl-15 pr-15 fs-10 c-secondary-neutral en-font">
            {IS_ARABIC && transferCreditDesc
              ? transferCreditDesc.ar
              : transferCreditDesc.en}
          </div>
        </If>
      </div>

      <div className="ml-15 mr-15">
        <div className="row pt-16 pb-16 bb-white-two ta-c">
          <div className="col-xs-6 pr-r-8">
            <img
              width="32"
              height="32"
              className=""
              src={RefundIcon}
              alt="flag"
            />
            <div className="mt-8 fw-6 fs-12 fw-16 c-dark-gray">
              {translate('Get Faster Refunds')}
            </div>
            <div className="mt-4 fs-12 lh-16 c-brown-gray">
              {translate('Get instant refunds on your orders as credits')}
            </div>
          </div>

          <div className="col-xs-6 pl-r-8">
            <img
              width="32"
              height="32"
              className=""
              src={RewardIcon}
              alt="flag"
            />
            <div className="mt-8 fw-6 fs-12 fw-16 c-dark-gray">
              {translate('Earn Rewards')}
            </div>

            <div className="mt-4 fs-12 lh-16 c-brown-gray">
              {translate('Earn credits as rewards & use it on your next order')}
            </div>
          </div>
        </div>

        <div className="mt-16 mb-16 fs-14 fw-6 lh-18 c-dark-gray">
          {translate('Transaction Log')}:
        </div>
      </div>

      <If condition={creditHistory && creditHistory.length}>
        <TransTable
          creditHistory={creditHistory}
          formatPrice={formatPrice}
          wrapperClasses="pb-16 bb-white-two ml-15 mr-15"
        />
      </If>
      <If condition={creditHistory && creditHistory.length === 0}>
        <div className="middle-xs center-xs mt-80 ">
          <img
            width="48"
            height="48"
            className=""
            src={SummaryIcon}
            alt="flag"
          />
        </div>
        <div className="c-brown-gray fs-12 mt-16 ta-c">
          {translate('No previous transactions')}
        </div>
      </If>

      <div
        className={classnames('flex between-xs ml-15 ls-072 mr-15 mt-40', {
          'mt-100': creditHistory && creditHistory.length === 0
        })}
      >
        <div
          className="fs-12 fw-6 lh-16 bb-brand-dashed"
          role="button"
          onClick={() => goToNext('terms')}
          onKeyPress={() => {
            goToNext('terms');
          }}
        >
          {translate('View T&Cs')}
        </div>
        <div
          className="fs-12 fw-6 lh-16 bb-brand-dashed"
          role="button"
          onClick={() => goToNext('faq')}
          onKeyPress={() => {
            goToNext('faq');
          }}
        >
          {translate('Check FAQs')}
        </div>
      </div>
    </div>
  );
};
